import { createContext } from '@flex-design-system/fx';

const [MiniProfileHoverPopoverProvider, useMiniProfileHoverPopoverContext] = createContext(
  "MiniProfileHoverPopover.Root"
);

export { MiniProfileHoverPopoverProvider, useMiniProfileHoverPopoverContext };
//# sourceMappingURL=context.mjs.map
